   
    <div class="uk-child-width-1-1@s" uk-grid>
        <div>
            <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
                style="background-image: url(../../assets/cakephpbanner.png);">
                <div class="uk-section uk-light">
                    <div class="uk-container-small uk-width-2xlarge" style="padding-top: 40px;">
                        <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;"> Cake PHP Application Development</h1></div>
                        <div>
                            <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">WebSoulLabs
                                 have a team of Developers who are expert in CakePHP, application framework to
                                  develop highly extensive and effective web applications.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
      
   
    <div class="uk-section uk-section-default" style="padding-top: 60px; padding-bottom: 30px;">
        <div class="uk-container">
            <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">CakePHP framework helps programmers
                 to work in a rapid as well as structured manner by supporting in every aspect of the application
                  development right from the initial stage of the project to the final delivery of the web page as
                   per the requirement of the client ensuring consistency, flow and logic of an application. CakePHP
                    with it’s top features and convention over configuration will decrease the amount of coding, thereby 
                    making the process of coding, deployment and maintenance of web applications at ease. WebSoulLabs
                     has a team of Highly Skilled CakePHP programmers to deliver creative, customized and cost effective
                      feature rich websites for our valuable clients and ensures in bringing great value to the project.  </p>
                
                <h2 class="uk-text-center" style="font-weight: 600;">CakePHP Services from WebSoulLabs </h2>
                <br>
            <div class="uk-column-1-2@s">
                
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">WebSoulLabs provides custom 
                    tailored & innovative solutions in CakePHP development services for our clients in various
                     industries ranging from Automation, Banking, Education, Social Media Networking, Sports,
                      Transport, Travel etc across the Globe. Using the latest and innovative solutions, our expert
                       team in CakePHP can provide solutions at a minimal amount of cost and time without compromising
                        the quality so that our clients would take-off the business to new heights where a competitive
                         advantage over their competitors is ensured. We develop custom tailored Web panels, web
                          applications and unique websites. We are proud to say that our developers not only just
                           work with great passion to fulfill the requirements of our clients. 
                   </p>
                <div>
                    <img data-src="assets/cake2.jpg" width="600" height="600" alt="" uk-img>
                </div>
            </div>
            <br>
            <div class="uk-column-1-2@s">
                <div>
                    <img data-src="assets/cake4.png" width="600" height="600" alt="" uk-img>
                </div>
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Our experienced developers
                     who loves to learn even further in CakePHP technology can handle any projects in CakePHP 
                     from a scratch and successfully deliver it within a reasonable time frame, which would be 
                     a high performing with flexible and custom tailored programming features. The high skilled
                      developers of WebSoulLabs ensures in providing a result-oriented & future-proof solutions
                       to meet the CakePHP development needs of our clients. Our principles of Client-First
                        approach, Timely & Reliable Support Services, Transparent pricing & policies and growth
                         centric approach ensures satisfaction of our valuable clients. Our skilled, creative, 
                         experienced developers with great understanding. </p>
               
            </div>
        </div>  <!--container div-->
    </div>  <!--div after banner-->
    <div class="uk-section uk-section-default" style="padding-top: 0px;">
        <div class="uk-container">
            <h2 class="uk-text-center" style="font-weight: 600;"><span>Why CakePHP services from WebSoulLabs? </span></h2>
            <br>
            <div class="uk-column-1-2@s">
                <div>
                    <img data-src="assets/cake3.jpg" width="600" height="600" alt="" uk-img>
                </div>
                <div>
                    <ul class="uk-list uk-list-disc uk-text-medium" style="font-size: 18px;">
                        <li>Customized CakePHP Development for our clients to develop unique internal business processes.</li>
                        <li>Integrate CakePHP solutions with our Client’s Accounting, CRM, ERP, MIS etc to ensure maximum efficiency and ease of operations.</li>
                        <li>To build prototypes in a quick and rapid manner without any complications. We utilize industry standard tools and plugins.</li>
                        <li>CakePHP Maintenance and Support services by WebSoulLabs will ensure security, helps in fixing bugs and routine maintenance
                             for a smooth & long run of your business.</li>
                    </ul>
                </div>
            </div>
        </div>  <!--container div-->
    </div>  <!--div after content-->

   

    <h1 class="uk-text-center" style="margin-bottom: 0px; margin-top: 0px;"><span>Related Services</span></h1>
    <BR><BR>
        
    <div class="uk-container">
        <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
            <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;" >
                
                    <img class="uk-align-center " src="../../assets/icons/cbg11.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">Custom Business<br> Application</h4>
            
                </div>
            </div>
        

            <div>
        
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;"  >
                    <img class="uk-align-center" src="../../assets/icons/phpg5.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">Php Application<br> Development</h4>

            
                </div>
        </div>


            <div>
        
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class="uk-align-center" src="../../assets/icons/laravelg6.png" width="100" height="100"
                        alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">Laravel Application Development</h4>

            
            </div>
        </div>

        <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class=" uk-align-center" src="../../assets/icons/cakeg8.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">CakePhp Application Development</h4>

            
            </div>
        </div>

        <div>
        
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class=" uk-align-center" src="../../assets/icons/pythong4.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">Python Programming Company</h4>

            
            </div>
        </div>

        <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                    <img class=" uk-align-center" src="../../assets/icons/shopifyg7.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style="font-weight: 600;">Ecommerce Web Development</h4>

            
            </div>
        </div>

        
        <div>
                <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                    <img class=" uk-align-center uk-border-pill" src="../../assets/icons/webdesigng12.png" width="100" height="100" alt="">
                    <h4 class="uk-text-center" style=" font-weight: 600;">Web Design And Development</h4>

                </div>
            </div>
        
        </div>

    </div>
    <h1 class="uk-text-center"><span>Technology Stack</span></h1>
    <br>
    <div class="uk-container">
        <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/thsss.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">WordPress</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/web3.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Angular js</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/Postgresql.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Postgres SQL</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/html.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Html</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-2@s uk-child-width-1-4@m uk-margin-large uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/css-3.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">CSS</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/Redis.png" width="120" height="120"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Redis</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/js-logo.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">JavaScript</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/jest.png" width="80" height="80"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Jest</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-2@s uk-child-width-1-4@m uk-margin-large uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/logo.png" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Redux</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/ruby.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Ruby On Rails</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/aws.png" width="130" height="130"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">AWS</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/ng.jpg" width="80" height="80"
                        alt="border-circle">
                    <h4 style="font-weight: 600;">Nginx</h4>
                </div>
            </div>
        </div>
    </div>
    <br>   
       
       
        
